export default __webpack_public_path__ + "static/media/GooglePlay.7ad0603c.png";